import { render, staticRenderFns } from "./BaseBreadcrumbs.vue?vue&type=template&id=c1fb389c"
import script from "./BaseBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./BaseBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./BaseBreadcrumbs.vue?vue&type=style&index=0&id=c1fb389c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports